import { useState, useEffect, useContext } from "react";
import Typography from "@material-ui/core/Typography";
import { Grid, Button, makeStyles } from "@material-ui/core";
import { ApptContext, EMRConfig } from "../../../../../../store";
import { useNavigate, useParams } from "react-router-dom";
import {
  ConfirmAppt,
  ConfirmParkinglot,
  GetAdminSettingValue,
  GetAppointmentType,
  GetPatientN,
  GetSchedulingPhone,
  LinkExpiry,
} from "../../../../../../api/PE_API";
import useStyles from "../../../../../../css/styles_PE";
import { Buffer } from "buffer";
import { InsertPPLogs } from "../../../../../../api";

// Update log
// FB  6192   02/06/2023  DK  Landing page after appointment booking
// FB  7112   07/20/2023  SK  Patient Portal: Add a new option to upload the insurance data below the Upload clinical documents option

export default function AppointmentFeatures(props: any) {
  var encodedAppt_n = "";
  var decodedAppt_n = "";
  var { apptId } = useParams();
  if (apptId != undefined) {
    encodedAppt_n = apptId;
    decodedAppt_n = Buffer.from(encodedAppt_n, "base64").toString();
  }
  var license = "";
  var { licenseName } = useParams();
  if (licenseName != undefined) {
    license = licenseName;
  }
  var appt_flag = 0;
  var { flag } = useParams();
  if (flag != undefined) {
    appt_flag = Number(flag);
  }
  const { state } = useContext(ApptContext);
  const [confirmParkingLot, setConfirmParkingLot] = useState("");
  const styles = useStyles();
  const navigate = useNavigate();
  const [returnValue, setReturnValue] = useState("");
  const [parkingLotMessage, setParkingLotMessage] = useState("");
  const [fontColor, setFontColor] = useState("limegreen");
  const [assisstanceMessage, setAssisstanceMessage] = useState("");
  const [pastMessage, setPastMessage] = useState("none");
  const [buttonsDisplay, setButtonsDisplay] = useState("initial");
  const [displayPastMessage, setDisplayPastMessage] = useState("");
  const [showPLMButton, setShowPLMButton] = useState<boolean>(false);
  const [displayCancelledMessage, setDisplayCancelledMessage] = useState("");
  const [cancelledMessage, setCancelledMessage] = useState("none");
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [showConfirmButton, setShowConfirmButton] = useState("flex");
  const [isIntakeAndUploadEnabled, setIsIntakeAndUploadEnabled] =
    useState<boolean>(true);
  const [isParkingLotEnabled, setIsParkingLotEnabled] = useState<boolean>(true);
  const [patN, setPatN] = useState("");
  const [appt_type, setAppt_type] = useState("In-Office");
  const [features, setFeatures] = useState([]);

  let obj = sessionStorage.getItem("EMRConfig");
  if (obj != null) {
    let config = JSON.parse(obj) as EMRConfig;
    var EMRbaseURL = config.EMRURL + "/";
  }
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }
  const confirmParkinglotClick = async (selected: string) => {
    InsertPPLogs(
      "Clicked on Check-in from office parking lot for patient" +
        patN +
        "  - Landing Page",
      window.location.href,
      userName,
      ""
    );
    setConfirmParkingLot(selected);
    const data = await ConfirmParkinglot(decodedAppt_n, license);
    setReturnValue(data);
    if (data == "Patient Arrival is confirmed") {
      setParkingLotMessage("Our office will be notified of your arrival");
      setFontColor("limegreen");
    }
  };
  const handleIntakeForms = () => {
    InsertPPLogs(
      "CLicked on Complete Health Forms ",
      window.location.href,
      userName,
      ""
    );
    const IntakeURL =
      EMRbaseURL + "patient_intake/note_add_edit.asp?app_n=" + encodedAppt_n;
    window.open(IntakeURL);
  };
  //FB 7112
  const handleFileUpload = (link: string) => {
    InsertPPLogs(
      "Clicked on Upload clinical/demographic documents",
      window.location.href,
      userName,
      ""
    );
    const Uploadurl =
      window.location.origin + "/user/fileupload/" + encodedAppt_n;
    // FB 7112
    sessionStorage.setItem("InsuranceCard", link);
    window.open(Uploadurl);
  };

  const handleDone = () => {
    InsertPPLogs(
      "Clicked on Done - Landing Page",
      window.location.href,
      userName,
      ""
    );
    navigate("/user/home/dashboard");
  };

  async function onload() {
    const linkExpiryReturnData = await LinkExpiry(decodedAppt_n, license);
    if (appt_flag == 0) {
      setShowConfirmButton("none");
      setShowPLMButton(false);
    }
    if (appt_flag == 1) {
      const data = await ConfirmAppt(Number(decodedAppt_n), license);

      if (linkExpiryReturnData == "Appointment is today") {
        if (appt_flag == 1) {
          setShowPLMButton(true);
        }
        if (data == "Appointment is confirmed") {
          setConfirmationMessage("Your appointment is confirmed");
        }
      }
      if (
        linkExpiryReturnData == "Appointment is in the present or future date"
      ) {
        setShowPLMButton(false);
        if (data == "Appointment is confirmed") {
          setConfirmationMessage("Your appointment is confirmed");
        }
      }
    }
    const SchedulingPhoneReturnData = await GetSchedulingPhone(
      decodedAppt_n,
      license
    );
    var cleaned = ("" + SchedulingPhoneReturnData).replace(/\D/g, "");
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    var phone = "";
    if (match) {
      phone = "(" + match[1] + ") " + match[2] + "-" + match[3];
    }

    if (linkExpiryReturnData == "Appointment is in the past") {
      setPastMessage("flex");
      setButtonsDisplay("none");
      setDisplayPastMessage(
        "The link you clicked on, is for the appointment that is already occured."
      );
      setAssisstanceMessage("For further assistance please call :" + phone);
      setFontColor("black");
    }
    if (linkExpiryReturnData == "Appointment is cancelled") {
      setCancelledMessage("flex");
      setButtonsDisplay("none");
      setDisplayCancelledMessage(
        "The link you clicked on, is for the appointment that is already cancelled."
      );
      setAssisstanceMessage("For further assistance please call :" + phone);
      setFontColor("black");
    }
  }

  async function GetApptType() {
    const appt_type = await GetAppointmentType(decodedAppt_n);
    setAppt_type(appt_type[0]);
  }

  async function GetFeatures() {
    const data = await GetAdminSettingValue("LandingPageFeatures");
    if (data != null && data != "") {
      setFeatures(data.split(";"));
    }
  }

  async function GetFlag() {
    let response = await GetAdminSettingValue(
      "Enable_PatientIntake_And_FileUpload_on_PE"
    );
    if (response.length != 0) {
      if (response == 1) {
        setIsIntakeAndUploadEnabled(true);
      } else {
        setIsIntakeAndUploadEnabled(false);
      }
    }
    let result = await GetAdminSettingValue("Enable_Parking_Lot_Management");
    if (result.length != 0) {
      if (result == 1) {
        setIsParkingLotEnabled(true);
      } else {
        setIsParkingLotEnabled(false);
      }
    }
    onload();
  }

  function GotoFeature(feature: string) {
    const IntakeURL =
      EMRbaseURL +
      "patient_intake/note_add_edit.asp?app_n=" +
      encodedAppt_n +
      "&template=" +
      feature;
    window.open(IntakeURL);
  }

  useEffect(() => {
    GetFlag();
    GetApptType();
    GetFeatures();
  }, []);

  return (
    <div>
      <section
        style={{
          margin: "10px 20px 20px",
        }}
      >
        <Grid container>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              alignItems: "center",
              justifyContent: "center",
              margin: "2%",
              display: pastMessage,
            }}
          >
            <Typography
              variant="h5"
              style={{ color: fontColor }}
              component="legend"
            >
              <br></br>
              {displayPastMessage}
            </Typography>
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              alignItems: "center",
              justifyContent: "center",
              margin: "2%",
              display: pastMessage,
            }}
          >
            <Typography
              variant="h5"
              style={{ color: fontColor }}
              component="legend"
            >
              <br></br>
              {assisstanceMessage}
            </Typography>
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              alignItems: "center",
              justifyContent: "center",
              margin: "2%",
              display: cancelledMessage,
            }}
          >
            <Typography
              variant="h5"
              style={{ color: fontColor }}
              component="legend"
            >
              <br></br>
              {displayCancelledMessage}
            </Typography>
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              alignItems: "center",
              justifyContent: "center",
              margin: "2%",
              display: cancelledMessage,
            }}
          >
            <Typography
              variant="h5"
              style={{ color: fontColor }}
              component="legend"
            >
              {assisstanceMessage}
            </Typography>
          </Grid>
        </Grid>
        <div style={{ display: buttonsDisplay }}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "2%",
            }}
          >
            <Typography style={{ fontSize: "1.1rem" }}>
              {isIntakeAndUploadEnabled
                ? "Prior to your appointment, Please fill out the Health Forms and upload any Clinical and Demographic documents using the buttons below:"
                : "Patient health forms and Document upload features are temporarily disabled. Apologies for the inconvenience."}
            </Typography>
          </Grid>
          <br />
          <Grid
            container
            style={{
              display: showConfirmButton,
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <Typography
              style={{ color: fontColor, fontFamily: "bold", fontSize: "18px" }}
            >
              {confirmationMessage}
            </Typography>
          </Grid>
          <br />
          <Grid
            container
            style={{
              display: isIntakeAndUploadEnabled ? "flex" : "none",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => handleIntakeForms()}
              className={styles.buttonInactive_LP}
            >
              Complete Health Forms
            </Button>
          </Grid>
          <br />
          <Grid
            container
            style={{
              display: isIntakeAndUploadEnabled ? "flex" : "none",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <Button
              variant="outlined"
              //FB 7112
              onClick={() => handleFileUpload("document")}
              className={styles.buttonInactive_LP}
            >
              Upload clinical/demographic documents
              {/* FB 7112 - Begin */}
            </Button>
          </Grid>
          <br />
          <Grid
            container
            style={{
              display: isIntakeAndUploadEnabled ? "flex" : "none",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => handleFileUpload("insuranceCard")}
              className={styles.buttonInactive_LP}
            >
              Upload Insurance Card
              {/* FB 7112 - End */}
            </Button>
          </Grid>
          <br />
          {features.length > 0 ? (
            features.map((feature: string) => (
              <>
                <Grid
                  container
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => GotoFeature(feature.split(":")[1])}
                    className={styles.buttonInactive_LP}
                    style={{
                      display: feature.toLowerCase().includes("tele")
                        ? appt_type.toLowerCase().includes("tele")
                          ? "flex"
                          : "none"
                        : "flex",
                    }}
                  >
                    {feature.split(":")[0]}
                  </Button>
                </Grid>
                <br />
              </>
            ))
          ) : (
            <></>
          )}

          <Grid
            container
            style={{
              justifyContent: "center",
              alignContent: "center",
              display: showPLMButton && isParkingLotEnabled ? "flex" : "none",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => confirmParkinglotClick("confirmParkingLot")}
              className={
                confirmParkingLot === "confirmParkingLot"
                  ? styles.buttonActive_LP
                  : styles.buttonInactive_LP
              }
            >
              Check-in from office parking lot
            </Button>
          </Grid>
          <Grid
            container
            style={{
              justifyContent: "center",
              alignContent: "center",
              display: "flex",
            }}
          >
            <Typography style={{ color: fontColor }}>
              {parkingLotMessage}
            </Typography>
          </Grid>
          <Grid container spacing={3} className={styles.flexend_Grid}>
            <Grid item>
              <Button
                onClick={handleDone}
                variant="contained"
                className={styles.navigationButton}
                id="done"
              >
                Done
              </Button>
            </Grid>
          </Grid>
        </div>
      </section>
    </div>
  );
}
